export default {
  labs: {
    label: 'Анализы',
    filterTitle: 'Фильтровать по статусу',
    search: 'Поиск анализов',
    status: {
      requested: 'Запрошен',
      completed: 'Завершен',
      canceled: 'Отменен',
    },
    filter: {
      all: 'Все статусы',
    },
    requests: {
      label: 'Запросы анализов',
      new: 'Новый запрос анализа',
      view: 'Посмотреть анализ',
      cancel: 'Отменить анализ',
      complete: 'Завершить анализ',
      error: {
        unableToRequest: 'Невозможно создать новый запрос анализа.',
        unableToComplete: 'Невозможно завершить анализ.',
        typeRequired: 'Необходимо указать тип.',
        resultRequiredToComplete: 'Необходимо указать результат.',
      },
    },
    lab: {
      code: 'Код анализа',
      status: 'Статус',
      for: 'Для',
      type: 'Тип',
      result: 'Результат',
      notes: 'Заметки',
      requestedOn: 'Когда запрошен',
      completedOn: 'Когда завершен',
      canceledOn: 'Когда отменен',
      patient: 'Пациент',
    },
  },
}
